import { render, staticRenderFns } from "./Scoolfolio.vue?vue&type=template&id=1d3574d1&scoped=true&"
import script from "@/views/Users/Student/Scoolfolio.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Student/Scoolfolio.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Student/scoolfolio.scss?vue&type=style&index=0&id=1d3574d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3574d1",
  null
  
)

export default component.exports